import React, {useEffect, useState} from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import deLocale from '@fullcalendar/core/locales/de';

import {getCurrentUserId, getCurrentUserRole} from '../utils/authHelper';
import {getSickEntries} from '../services/SickDayService';
import {getHolidayEntries} from '../services/HolidayService';
import {getPublicHolidays} from '../services/PublicHolidayServices';
import '../styles/Calendar.css';

export default function AbsenceCalendar() {
    const [events, setEvents] = useState([]);

    const userId = getCurrentUserId();
    const role = getCurrentUserRole();

    useEffect(() => {
        (async () => {
            await loadCalendarData();
        })();
    }, []);

    const loadCalendarData = async () => {
        const eventsList = [];

        try {
            const [holidays, sick_days, publicHolidays] = await Promise.all([
                getHolidayEntries({role, userId}),
                getSickEntries({role, userId}),
                getPublicHolidays()
            ]);

            // Holiday
            holidays.forEach(e => {
                const start = new Date(e.startDate);
                const end = new Date(e.endDate);

                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                    eventsList.push({
                        title: role === 'admin' ? `Urlaub – ${e.displayName}` : 'Urlaub',
                        date: new Date(d).toISOString().split('T')[0],
                        color: '#4caf50'
                    });
                }
            });

            // Sick days
            sick_days.forEach(e => {
                const start = new Date(e.startDate);
                const end = new Date(e.endDate);

                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                    eventsList.push({
                        title: role === 'admin' ? `Krank – ${e.displayName}` : 'Krank',
                        date: new Date(d).toISOString().split('T')[0],
                        color: '#f44336'
                    });
                }
            });

            // Holidays
            publicHolidays.forEach(e => {
                eventsList.push({
                    title: `Feiertag – ${e.description}`,
                    date: e.date,
                    color: '#2196f3'
                });
            });

            setEvents(eventsList);
        } catch (err) {
            console.error('Fehler beim Laden der Kalenderdaten:', err);
        }
    };

    return (
        <div className="calendar-wrapper">
            <h3>Kalenderübersicht</h3>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                locale={deLocale}
                events={events}
                height="auto"
            />
        </div>
    );
}
